import type { ConfigurableServer } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { Tabs } from '@festina-life/ui/structure'
import { useMemo } from 'react'

import { ManageServer } from './ManageServer'

type Props = {
  server: ConfigurableServer
}

export const ServerDetailsTabs = ({ server }: Props) => {
  const translate = useTranslate()
  const tabItems = useMemo(
    () => [
      {
        key: 'manage',
        title: translate('serverDetailsPanel.tabs.manage.title'),
      },
    ],
    [translate],
  )

  return (
    <Tabs
      items={tabItems}
      selectedIndex={0}
      onChange={() => {}}
      panelClassName="overflow-auto h-full"
      tabGroupClassName="h-full flex flex-col"
      tabItemsClassName="w-full"
    >
      {[<ManageServer key="manage" server={server} />]}
    </Tabs>
  )
}
